import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.support.'

@vsingleton()
export class AdminLatestNewsRoutes extends RouteBase {
  prefix = ROUTE_PREFIX + 'latest-news.'

  index() {
    return this.ziggyRoute('index')
  }

  store() {
    return this.ziggyRoute('store')
  }

  edit(latest_news) {
    return this.ziggyRoute('edit', latest_news)
  }

  update(latest_news) {
    return this.ziggyRoute('update', latest_news)
  }

  destroy(latest_news: number) {
    return this.ziggyRoute('destroy', latest_news)
  }

}
